import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import {
  CardHeader,
  CircularProgress,
  Container,
  IconButton,
  ListItemButton,
  Skeleton,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DeleteIcon from "@mui/icons-material/Delete";
import { Stack, Tooltip } from "@mui/material";
import { DeleteOutline, FitScreen } from "@mui/icons-material";
import { EditCalendarTwoTone } from "@mui/icons-material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import styled from "@emotion/styled";
import { Radio } from "@mui/material";
import { DeleteFolderIcon } from "../../../../assets/FileRepositoryIcon";
import { RenameFolderIcon } from "../../../../assets/FileRepositoryIcon";
import { FileImport } from "../../../../assets/FileRepositoryIcon";
import DialogBoxForm from "../DialogBoxFileRepositoryForm";
import { useFileRepository } from "../../FileRepositoryContext";
import { CSDataTableColumns } from "../../../../modal/CSDataTable";
import CSDataTable from "../../../../components/CSDataTable";
import { FileList, FolderList } from "../../modal";
import { convertToDateMonthFormat } from "../../../../utils/ConvertDate";
import DialogBoxComponent from "../../../../components/DialogBoxComponent";
import { useAccessRights } from "../../../../utils/useAccessRights";

import {
  fetchFileList,
  uploadFiles,
  deleteFiles,
  downloadFiles,
  fetchUserDetails,
  createFolder,
  fetchFolderList,
} from "../../helper";
import { useUserContext } from "../../../../context/auth/UserContext";
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  "&::-webkit-scrollbar": {
    width: "10px",
    height: "10px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1", // Change as needed
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#888", // Change as needed
    borderRadius: "10px", // Apply border-radius here
    border: "2px solid #f1f1f1", // Change as needed
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#555",
  },
}));

const columns: CSDataTableColumns[] = [
  {
    accessorKey: "fileName",
    header: "File Name",
    size: "200px",
  },
  {
    accessorKey: "uploadDate",
    header: "Date Uploaded",
    size: "80px",
  },
  {
    accessorKey: "uploadedName",
    header: "Uploaded by",
    size: "80px",
  },
];

export default function ViewFileRepositoryList() {
  const {
    selectedFolder,
    setSelectedFolder,
    folderList,
    setFolderList,
    setRefreshFolderList,
  } = useFileRepository();

  const fileRepoAccess = useAccessRights("File Repository");

  const [selectedFile, setSelectedFile] = useState<any[]>([]);
  const [fileList, setFileList] = useState<FileList[]>([]);
  const [isLoadingFileList, setIsLoadingFileList] = useState<boolean>();

  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openDeleteConfirmationDialog: false,
    openSuccessDialogBox: false,
  });
  const [dialogForm, setDialogForm] = useState({
    title: "",
    action: "",
    actionCancel: "",
    openDialogCreate: false,
    openDialogUpload: false,
  });

  const { userId, companyProfileID } = useUserContext();

  const hasFetched = useRef(false);
  const handleFetchFileList = async () => {
    // console.log("handleFetchFileList selectedFolder", selectedFolder);

    try {
      const res = await fetchFileList(selectedFolder);

      const userList = await fetchUserDetails();
      console.log("handleFetchFileList userList", userList);

      let list = res?.map((ele: any) => ({
        ...ele,
        rowId: ele.fileId,
        uploadDate: convertToDateMonthFormat(ele.createDate),
        uploadedName: userList.find(
          (user: any) => user.userID === ele.createdBy
        ).userName,
      }));

      setFileList(list);
    } catch (error) {
    } finally {
      setIsLoadingFileList(false);
    }
  };

  const handleDeleteFilesApi = async () => {
    try {
      const fileIds = selectedFile.map((file) => file.fileId);
      let payload = {
        folderName: selectedFolder?.folderName,
        fileIds: fileIds,
      };
      const res = await deleteFiles(payload);
      // console.log("handleDeleteFilesApi", "res", res);
      if (res) {
        // console.log("handleDeleteFilesApi payload", selectedFile);
        handleFetchFileList();
        setRefreshFolderList(true);
        setDialogState({
          title: "Success",
          body: res.message,
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        });
      } else {
        handleFetchFileList();
        setRefreshFolderList(true);
        setDialogState({
          title: "Error",
          body: "An error occurred while deleting the folder.",
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        });
      }
    } catch (error) {
      // console.log("@@Error:", error);
    } finally {
      // setLoadingFolderList(false)
    }
  };
  const handleDownloadFilesApi = async () => {
    try {
      let payload = {
        folderId: selectedFolder?.folderId,
        folderName: selectedFolder?.folderName,
        fileId: selectedFile[0].fileId,
        fileName: selectedFile[0].fileName,
        folderId: selectedFile[0].folderId,
      };
      // console.log("handleDownloadFilesApi", "payload", selectedFile, payload);

      const res = await downloadFiles(payload);
    } catch (error) {
      // console.log("@@Error:", error);
    } finally {
    }
  };

  const handleUploadFileApi = async (file: File[] | null) => {
    // console.log("handleUploadFileApi", file);
    const res = await uploadFiles(file, selectedFolder, userId);
    // console.log("res", res);

    if (res.message) {
      // console.log("handleUploadFileApi ", "res", res);
      handleFetchFileList();
      setRefreshFolderList(true);
      setDialogState({
        title: "Success",
        body: "File(s) has been successfully uploaded",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    } else {
      setRefreshFolderList(true);
      setDialogState({
        title: "Error",
        body: "An error occurred while creating files.",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    }
  };

  const handleUploadFileClick = () => {
    setDialogForm({
      title: "Upload Files",
      action: "Upload",
      actionCancel: "Cancel",
      openDialogCreate: false,
      openDialogUpload: true,
    });
  };

  const handleUploadFileConfrmed = (
    folderName?: string,
    folderData?: FolderList | null,
    file?: File[] | null
  ) => {
    // console.log("handleUploadFileConfrmed", "file", file);
    handleCloseDialogBoxForm();
    setIsLoadingFileList(true);

    handleUploadFileApi(file || []);
  };
  const handleDeleteConfirmed = () => {
    // console.log("handleRenameConfirmed", "folderName",);
    handleCloseDialog();
    setIsLoadingFileList(true);
    handleDeleteFilesApi();
  };
  const handleDeleteClick = () => {
    // console.log("handleDeleteClick selectedFile", selectedFile);
    setDialogState({
      title: "Confirm",
      body: `Are you sure you want to delete ${selectedFile.length > 1 ? "selected files" : `<strong>${selectedFile[0].fileName}</strong>`
        }`,
      action: "OK",
      actionCancel: "CANCEL",
      openDeleteConfirmationDialog: true,
      openSuccessDialogBox: false,
    });
  };
  const handleDownloadFiles = () => {
    handleDownloadFilesApi();
  };
  const handleCloseDialogBoxForm = () => {
    setDialogForm({
      ...dialogState,
      openDialogCreate: false,
      openDialogUpload: false,
    });
  };

  const handleSelectRow = (selectedRows: any) => {
    // console.log("handleSelectRow", selectedRows);
    setSelectedFile(selectedRows);
  };

  const handleCloseDialog = () => {
    setDialogState({
      ...dialogState,
      openDeleteConfirmationDialog: false,
      openSuccessDialogBox: false,
    });
  };

  const handleAddNewFolder = () => {
    // console.log("handleCAddNewFolder");
    setDialogForm({
      title: "Create Folder",
      action: "Create",
      actionCancel: "Cancel",
      openDialogCreate: true,
      openDialogUpload: false,
    });
  };

  const handleAddFolderConfirmed = (folderName: string) => {
    // handleCloseFolderDialog();
    // setLoadingFolderList(true);
    // console.log("handleAddFolderConfirmed folderName", folderName);
    let payload = {
      folderName: folderName,
      description: folderName,
      companyProfileID: companyProfileID,
      parentFolderId: selectedFolder?.folderId,
      createDate: new Date(),
      createdBy: userId,
    };
    // console.log("handleAddFolderConfirmed payload", payload);

    handleCreateFolder(payload);
  };

  const handleCloseFolderDialog = () => {
    setDialogForm({
      title: "",
      action: "",
      actionCancel: "",
      openDialogCreate: false,
      openDialogUpload: false,
    });
  };

  const handleCreateFolder = async (payload: any) => {
    try {
      const res = await createFolder(payload);
      // console.log("handleCreateFolder", "res", res.succeeded);
      if (res.succeeded) {
        // console.log("handleCreateFolder payload", payload);

        handleFetchFolderList();
        setDialogState({
          title: "Success",
          body: `<strong>${payload.folderName}</strong> is created successfully`,
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        });
      } else {
        setDialogState({
          title: "Error",
          body: "An error occurred while creating the folder.",
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        });
      }
    } catch (error) {
      // console.log("@@Error:", error);
    } finally {
      // setLoadingFolderList(false)
    }
  };

  const organizeFolders = (folders: any) => {
    const folderMap = new Map();

    folders.forEach((folder: any) => {
      folderMap.set(folder.folderId, {
        ...folder,
        rowId: folder.folderId,
        subFolders: [],
      });
    });

    let rootFolders: any[] = [];

    folders.forEach((folder: any) => {
      if (folder.parentFolderId) {
        const parentFolder = folderMap.get(folder.parentFolderId);
        if (parentFolder) {
          parentFolder.subFolders.push(folderMap.get(folder.folderId));
        }
      } else {
        rootFolders.push(folderMap.get(folder.folderId));
      }
    });

    return rootFolders;
  };

  const handleFetchFolderList = async () => {
    try {
      const res = await fetchFolderList(companyProfileID);
      // console.log("handleFetchFolderList", "res", res);

      let list = await organizeFolders(res);
      // console.log("handleFetchFolderList list", list);

      setFolderList(list);
    } catch (error) {
      // console.log("@@Error:", error);
    } finally {
      setRefreshFolderList(false);
    }
  };

  useEffect(() => {
    if (selectedFolder) {
      // console.log("selectedFolder", selectedFolder);
      setIsLoadingFileList(true);
      // if (!hasFetched.current) {
      handleFetchFileList();
      // hasFetched.current = true;
      // }
      // console.log("hasFetched", hasFetched)
    }
  }, [selectedFolder]);

  return (
    <React.Fragment>
      <Card
        sx={{
          width: "100%",
          height: "100%",
          borderRadius: "10px",
          maxHeight: { xs: "80vh", md: "100%" },
          maxWidth: { xs: "100%", md: "100%" },
        }}
      >
        <CardContent sx={{ height: 465 }}>
          <Grid container direction="column" spacing={1}>
            <Grid xs={12}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Tooltip title={selectedFolder?.folderName && selectedFolder?.folderName?.length > 20 ? selectedFolder?.folderName : ""}>
                  <Typography
                    variant="h6"
                    noWrap
                    sx={{
                      maxWidth: "200px", // Set a maximum width to trigger ellipsis
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {selectedFolder?.folderName}
                  </Typography>
                </Tooltip>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Button
                    size="small"
                    variant="contained"
                    className="table-btn"
                    onClick={handleAddNewFolder}
                    disabled={
                      !selectedFolder ||
                      !!selectedFolder?.parentFolderId ||
                      !fileRepoAccess?.isUpload
                    }
                  >
                    Add New Folder
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    className="table-btn"
                    onClick={handleUploadFileClick}
                    disabled={!selectedFolder || !fileRepoAccess?.isUpload}
                  >
                    Upload Files
                  </Button>

                  <Tooltip title="Download File">
                    <IconButton
                      disabled={
                        selectedFile.length !== 1 || !fileRepoAccess?.isDownload
                      }
                      onClick={handleDownloadFiles}
                      size="small"
                    >
                      {React.createElement(FileImport, {
                        opacity:
                          selectedFile.length !== 1 ||
                            !fileRepoAccess?.isDownload
                            ? "50%"
                            : "100%",
                      })}
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete File">
                    <IconButton
                      disabled={
                        selectedFile.length === 0 || !fileRepoAccess?.isDelete
                      }
                      onClick={handleDeleteClick}
                      size="small"
                    >
                      {React.createElement(DeleteFolderIcon, {
                        opacity:
                          selectedFile.length === 0 || !fileRepoAccess?.isDelete
                            ? "50%"
                            : "100%",
                      })}
                    </IconButton>
                  </Tooltip>
                </Box>
              </Stack>
            </Grid>
            <Grid xs={12}>
              {isLoadingFileList ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : folderList && folderList?.length > 0 ? (
                selectedFolder?.folderId ? (
                  fileList.length > 0 ? (
                    <CSDataTable
                      rows={fileList}
                      columns={columns}
                      multiRowSelection={true}
                      // rowActions={rowActions}
                      // selection={true}

                      handleSelectRow={(selectedRows) =>
                        handleSelectRow(selectedRows)
                      }
                    />
                  ) : (
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Typography
                        sx={{
                          mt: 3,
                          opacity: 0.7,
                          fontWeight: 400,
                          fontStyle: "italic",
                        }}
                      >
                        {`There are no files in ${selectedFolder?.folderName}`}
                      </Typography>
                    </Box>
                  )
                ) : (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Typography
                      sx={{
                        mt: 3,
                        opacity: 0.7,
                        fontWeight: 400,
                        fontStyle: "italic",
                      }}
                    >
                      Please click folder to display the files
                    </Typography>
                  </Box>
                )
              ) : (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Typography
                    sx={{
                      mt: 3,
                      opacity: 0.7,
                      fontWeight: 400,
                      fontStyle: "italic",
                    }}
                  >
                    Folder is empty
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {
        //Create new folder
        <DialogBoxForm
          parentFolderId={selectedFolder?.folderId}
          openDialogBox={dialogForm.openDialogCreate}
          dialogTitle={dialogForm.title}
          dialogAction={dialogForm.action}
          dialogActionCancel={dialogForm.actionCancel}
          handleFunction={handleAddFolderConfirmed}
          handleCancel={handleCloseFolderDialog}
        />
      }
      {
        //Upload Files Dialog
        <DialogBoxForm
          openDialogBox={dialogForm.openDialogUpload}
          dialogTitle={dialogForm.title}
          dialogAction={dialogForm.action}
          dialogActionCancel={dialogForm.actionCancel}
          handleFunction={handleUploadFileConfrmed}
          handleCancel={handleCloseDialogBoxForm}
        />
      }
      {
        //Delete Conformation
        <DialogBoxComponent
          openDialogBox={dialogState.openDeleteConfirmationDialog}
          dialogTitle={dialogState.title}
          dialogBody={dialogState.body}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          handleFunction={handleDeleteConfirmed}
          handleCancel={handleCloseDialog}
        />
      }
      {
        //Delete Conformation
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogBody={dialogState.body}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          handleFunction={handleCloseDialog}
        />
      }
    </React.Fragment>
  );
}
